import React from "react";
import { FaBook, FaLanguage, FaListUl } from "react-icons/fa";

import { DEFAULT_LEXIQUE_IMAGE } from "../utils/lexiqueUtils";

function HeroStat({ icon: Icon, label, value }) {
  return (
    <div className="rounded-[1.5rem] border border-white/10 bg-white/10 p-4 text-white backdrop-blur-xl">
      <Icon className="text-indigo-200" />
      <p className="mt-3 text-2xl font-bold">{value}</p>
      <p className="text-xs font-bold uppercase tracking-[0.14em] text-white/50">
        {label}
      </p>
    </div>
  );
}

function LexiqueHero({ discipline, stats }) {
  return (
    <header className="relative overflow-hidden bg-slate-950">
      <div className="absolute inset-0">
        <img
          src={DEFAULT_LEXIQUE_IMAGE}
          alt="Lexique"
          className="h-full w-full object-cover opacity-45"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-950/80 to-indigo-950/70" />
      </div>

      <div className="relative mx-auto flex min-h-[380px] w-full max-w-[1280px] flex-col justify-end px-4 pb-20 pt-12 sm:px-6 lg:px-8">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white backdrop-blur-xl">
            <FaLanguage />
            {discipline || "Judo"}
          </div>

          <h1 className="mt-5 font-titre text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Lexique technique
          </h1>

          <p className="mt-5 max-w-2xl text-base font-medium leading-8 text-white/75 sm:text-lg">
            Retrouvez les termes japonais, leurs traductions et le vocabulaire
            utile pour les cours, les passages de grades et les révisions.
          </p>
        </div>

        <div className="mt-8 grid max-w-4xl gap-3 sm:grid-cols-3">
          <HeroStat icon={FaBook} label="Termes" value={stats.total} />
          <HeroStat icon={FaListUl} label="Lettres" value={stats.letters} />
          <HeroStat
            icon={FaLanguage}
            label="Traductions"
            value={stats.withTranslation}
          />
        </div>
      </div>
    </header>
  );
}

export default LexiqueHero;